import { TopMenu } from "../../top-menu/TopMenu";
import { Footer } from "../../footer/Footer";
import TeamWork from '../../../assets/Teamwork_original_537665.jpg';

export const Mission = () => (
    <div className="min-h-screen flex flex-col">
        <TopMenu />
        <main className="flex-1 py-10 px-5 grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="text-justify">
                <h1 className="bg-navy text-white pl-2.5 mt-0">MISSION STATEMENT</h1>
                <h2 className="text-navy">As a Company</h2>
                <p>Our mission is to provide high-quality steel shop drawings and models that meet and exceed our
                    customers' expectations. By utilizing the latest technology and adhering to strict AISC
                    standards, we ensure every project is accurate, complete, and facilitates efficient coordination
                    for our clients' success.</p>
                <h2 className="text-navy">As an individual</h2>
                <p>At Rocky Point Detailing, we are dedicated to building a special place to work, founded on professional excellence, integrity, and honesty. We commit to a positive, collaborative environment where every team member contributes to our collective goal: delivering accurate and on-time results for every project.</p>
            </div>
            <div className="md:col-span-2 text-center">
                <img src={TeamWork} alt="Team" className="w-4/5 mx-auto block" />
            </div>
        </main>
        <Footer />
    </div>
);
